
// Function for rendering the checkbox column
export const renderGridCheckboxColumn = (rowData, col, rowIndex, onActionHandler) => {
  const isDisabled = col.colSettings ? !col.colSettings.allowEdit : false;
  const isChecked = rowData[col.fieldName];

  const handleCheckboxChange = (actionName, data, field,checked) => {
    if (onActionHandler) {
      if (onActionHandler[actionName]) {
        onActionHandler[actionName](data, field,checked);
      }
    }
  }

  return (
    <>
      {/* <Checkbox
        checked={isChecked}
        disabled={isDisabled}
        onChange={handleCheckboxChange}
      /> */}
      <input
        type="checkbox"
        checked={isChecked}
        disabled={isDisabled}
        onChange={(e) => handleCheckboxChange("CHECKBOX", rowData, col.fieldName,e.target.checked)}
      />
    </>
  );
};
